import React from 'react';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import get from 'lodash-es/get';
import PropTypes from 'prop-types';

const CheckboxButton = ({ field, form, ...props }) => {
    const current = field.name;
    const currentValue = get(form.values, current);
    return (
        <FormControlLabel
            {...props}
            {...field}
            checked={currentValue}
            value={''}
            control={<Checkbox />}
        />
    );
};

CheckboxButton.propTypes = {
    form: PropTypes.object,
    field: PropTypes.object,
    value: PropTypes.string,
};

export default CheckboxButton;
